<span class="title">{{ dataContext.title | translate }}</span>
<div cdkDropList class="item-list" (cdkDropListDropped)="drop($event)">
  @for (item of orderedItems; track item) {
    <div class="item-box" cdkDrag>{{ item.name }}</div>
  }
</div>
